import { LoadingButton } from "@mui/lab";
import { Alert, AlertColor, Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Snackbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import socket, { IResponse } from "../../socket";
import serviceList, { IService } from "./ServiceList";

interface ISnackbar {
    type: AlertColor,
    message: string,
    open: boolean,
}

export default function Services() {
    const { t } = useTranslation();
    const [topServices, setTopServices] = useState<IService[]>([]);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState<ISnackbar>({open: false, message: '', type: 'success'});

    const handleChange = (event: SelectChangeEvent<IService[]>) => {
        setTopServices((services) => {
            // @ts-ignore
            const selected: number[] = event.target.value
            const s = serviceList.find(service => service.id === selected[selected.length - 1]);
            console.log(event.target.value);

            if (s) {
                return [...services, s];
            }
            return services;
        });
    };

    useEffect(() => {
        socket.emit("home:top_services", null, (data: IResponse<number[]>) => {
            setLoading(false);            
            if (data.success) {
                setTopServices(serviceList.filter(service => data.result.includes(service.id)));
            } else {
                setSnackbar({
                    open: true,
                    type: 'error',
                    message: data.error,
                })
            }
        })
    }, []);

    const handleCloseSnackbar = () => {
        setSnackbar({...snackbar, open:false});
    }

    const handleEditTopServices = () => {
        setLoading(true);
        socket.emit('home:edit_top_services', topServices.map(service => service.id), (data: IResponse<null>) => {
            setLoading(false);
            if (data.success) {
                setSnackbar({
                    open: true,
                    type: 'success',
                    message: t('edit_top_services_successfully'),
                })
            } else {
                setSnackbar({
                    open: true,
                    type: 'error',
                    message: data.error,
                })
            }
        });
    }

    return (
        <div className="mx-4 mt-4 flex flex-col space-y-3">
            <Typography className="font-bold text-lg" gutterBottom>{t('services_settings')}</Typography>
            <Typography>{t('top_services_description')}</Typography>
            <FormControl className="w-80">
                <InputLabel>{t('top_services')}</InputLabel>
                <Select
                    multiple
                    value={topServices}
                    onChange={handleChange}
                    input={<OutlinedInput label={t('top_services')} />}
                    renderValue={(selected) => (
                        <Box className="flex flex-wrap gap-1">
                            {selected.map((service) => (
                                <Chip
                                    onMouseDown={(event) => {
                                        event.stopPropagation();
                                    }}
                                    key={service.id}
                                    label={service.name}
                                    onDelete={() => setTopServices((services) => services.filter(s => s.id !== service.id))} />
                            ))}
                        </Box>
                    )}
                >
                    {serviceList.map((service) => (
                        <MenuItem
                            key={service.id}
                            value={service.id} sx={{ bgcolor: topServices.some(s => s.id === service.id) ? 'primary.light' : '' }}>
                            {service.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <LoadingButton className="w-20" loading={loading} onClick={handleEditTopServices} variant='contained'>{t('edit')}</LoadingButton>
            <Snackbar open={snackbar.open} autoHideDuration={5000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.type} sx={{ width: '100%' }}>
                    { snackbar.message }
                </Alert>
            </Snackbar>
        </div>
    )
}
